import { ApiService } from '@/api';
import { cloneDeep } from 'lodash';
import { ref, computed } from 'vue';

type CategoryList = Awaited<ReturnType<typeof ApiService.getCategories>>;
type CategoryItem = CategoryList[number];
export type Category = CategoryItem & { children?: CategoryList };

const data = ref<CategoryList>([]);

export function useCategory() {
    const update = (payload: any) => {
        data.value = payload;
    };

    const fetch = async () => {
        const categories = await ApiService.getCategories({});
        data.value = categories;
    };

    function tree(items: CategoryList): CategoryList {
        const root: CategoryList = [];
        const lookup: { [k: string]: Category } = {};
        items.forEach((item) => (lookup[item.id] = { ...item, children: [] }));
        items.forEach((item) => {
            if (item.parentId) lookup[item.parentId].children?.push(lookup[item.id]);
            else root.push(lookup[item.id]);
        });
        return root;
    }

    const categories = computed(() => {
        const items = cloneDeep(data.value || []);
        return tree(items);
    });

    const getCategory = (id: string | number) => {
        return data.value.find((x) => x.id == id);
    };

    const getCategoryPath = (id: string | number) => {
        let c = getCategory(id);
        let path = [];
        while (c) {
            path.push(c.title);
            c = c.parentId ? getCategory(c.parentId) : undefined;
        }
        return path.reverse();
    };

    return {
        categories,
        getCategory,
        getCategoryPath,
        update,
        fetch,
    };
}
